// Landing-page event tracking, kept apart from the UI so a provider can be
// swapped without touching components.
//
// There is no analytics SDK in the app yet. Events go to `window.dataLayer`
// (Google Tag Manager's queue) when a tag is installed, and are otherwise
// dropped, so calling track() is always safe.

import type { ExploreCardId } from "./landingContent";

const SCREEN = "landing_page";

interface LandingEventMap {
  landing_view: Record<string, never>;
  hero_cta_clicked: Record<string, never>;
  hero_secondary_cta_clicked: Record<string, never>;
  explore_card_clicked: { card: ExploreCardId };
  pricing_viewed: Record<string, never>;
  plan_selected: { plan: "free" | "pro" | "global" | "energy_match" };
  free_signup_started: { source: string };
}

export type LandingEventName = keyof LandingEventMap;

interface WindowWithDataLayer extends Window {
  dataLayer?: Record<string, unknown>[];
}

type EventArgs<E extends LandingEventName> =
  LandingEventMap[E] extends Record<string, never> ? [] : [LandingEventMap[E]];

export const trackLanding = <E extends LandingEventName>(
  name: E,
  ...args: EventArgs<E>
): void => {
  try {
    (window as WindowWithDataLayer).dataLayer?.push({
      event: name,
      screen: SCREEN,
      ...(args[0] as Record<string, unknown> | undefined),
    });
  } catch {
    // Analytics must never break the page.
  }
};
